import { call, put } from 'redux-saga/effects';
import { showToastMessage } from '../../services/notification';

import api, { makeOptions } from '../../services/api';
import FilmagemPublicaListActions from '../ducks/filmagem-publica-list';

const dataLocal = JSON.parse(localStorage.getItem('persist:Spcine'));
// const getAuthData = (state) => state.auth.data;

export function* fetch() {
  try {
    // const authData = yield select(getAuthData);
    const url = `/ld-filmagem-publica`;
    const { data: responseData } = yield call(
      api.get,
      url,
      makeOptions(dataLocal.auth.data),
    );
    const { data, ...pagination } = responseData;
    yield put(FilmagemPublicaListActions.success(data, pagination));
  } catch (err) {
    yield put(
      FilmagemPublicaListActions.failure(err.response.data.error.message),
    );
    showToastMessage({
      type: 'error',
      text: err.response.data.error.message,
    });
  }
}

export function* fetchSelect() {
  try {
    // const authData = yield select(getAuthData);
    const url = `/ld-filmagem-publica?paginate=false`;
    const { data: responseData } = yield call(
      api.get,
      url,
      makeOptions(dataLocal.auth.data),
    );
    const { data } = responseData;
    const list = data.map(({ uuid, name }) => ({
      value: uuid,
      label: name,
    }));

    yield put(FilmagemPublicaListActions.showSuccess(list));
  } catch (err) {
    yield put(
      FilmagemPublicaListActions.showFailure(err.response.data.error.message),
    );
    showToastMessage({
      type: 'error',
      text: err.response.data.error.message,
    });
  }
}
